import { Metrics } from '../metrics/metrics';
export const createEmissionBuffer = ({
  onFlush
}) => {
  let pending = new Map();
  let flushScheduled = false;
  let firstScheduledAt = 0;
  const flush = () => {
    const batch = pending;
    pending = new Map();
    flushScheduled = false;
    if (firstScheduledAt > 0) {
      Metrics.timer('emissionBuffer.flushDelay').update(performance.now() - firstScheduledAt);
      firstScheduledAt = 0;
    }
    for (const [instanceKey, state] of batch) {
      onFlush(instanceKey, state);
    }
  };
  return {
    schedule: (instanceKey, state) => {
      pending.set(instanceKey, state);
      if (!flushScheduled) {
        flushScheduled = true;
        firstScheduledAt = performance.now();
        queueMicrotask(flush);
      }
    }
  };
};